import { FormHelperText, Typography } from '@mui/material';

import { FieldError } from '@components/LoadSearchTemplateDialog/templateFormControls/types';

/**
 * [LIST-1063] Styles the helper text differently if its an error about lacking
 * election roster data
 */
export default function CustomFormHelperText({ fieldError }: { fieldError: FieldError }) {
  if (fieldError?.reason === 'noElectorates') {
    return (
      <Typography component="p" sx={{ marginTop: '0px', marginBottom: '0px' }}>
        {fieldError.helperText}
      </Typography>
    );
  }

  return <FormHelperText className="Mui-error">{fieldError.helperText}</FormHelperText>;
}
